import { render, staticRenderFns } from "./normalInput.vue?vue&type=template&id=56bdbbae"
import script from "./normalInput.vue?vue&type=script&lang=js"
export * from "./normalInput.vue?vue&type=script&lang=js"
import style0 from "./normalInput.vue?vue&type=style&index=0&id=56bdbbae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports